import { Nominee, UpsertNomineesRequest } from '../../../proto/generated/trading-bridge'
import {
    NomineeChangeRequest,
    NomineeChangeRequestStatus
} from './nomineeChangeRequest.types'
import { normalizeNominees } from './nomineeHelpers'

const parseStatus = (value: unknown): NomineeChangeRequestStatus => {
    if (typeof value === 'number') {
        return value as NomineeChangeRequestStatus
    }
    if (typeof value === 'string') {
        const normalized = value.toUpperCase()
        if (normalized.includes('PENDING')) return NomineeChangeRequestStatus.PENDING
        if (normalized.includes('APPROVED')) return NomineeChangeRequestStatus.APPROVED
        if (normalized.includes('REJECTED')) return NomineeChangeRequestStatus.REJECTED
    }
    return NomineeChangeRequestStatus.UNKNOWN
}

const parseNominee = (raw: any): Nominee => ({
    id: Number(raw?.id ?? 0),
    nomineeOrder: Number(raw?.nomineeOrder ?? raw?.nominee_order ?? 0),
    name: raw?.name ?? '',
    relationship: raw?.relationship ?? '',
    allocationPercent: Number(raw?.allocationPercent ?? raw?.allocation_percent ?? 0),
    dob: raw?.dob ?? '',
    pan: raw?.pan ?? '',
    address: raw?.address ?? '',
    minor: Boolean(raw?.minor),
    guardian: raw?.guardian
        ? {
            name: raw.guardian.name ?? '',
            relationship: raw.guardian.relationship ?? '',
            pan: raw.guardian.pan ?? ''
        }
        : { name: '', relationship: '', pan: '' },
    proofDocumentId: Number(raw?.proofDocumentId ?? raw?.proof_document_id ?? 0)
})

export const normalizeNomineeChangeRequest = (raw: any): NomineeChangeRequest | null => {
    if (!raw) return null

    const nomineesRaw = raw.nominees ?? raw.requestedNominees ?? raw.requested_nominees
    if (!Array.isArray(nomineesRaw)) {
        return null
    }

    return {
        id: Number(raw.id ?? 0),
        status: parseStatus(raw.status),
        nominees: normalizeNominees(nomineesRaw.map(parseNominee)),
        requestedAt: Number(raw.requestedAt ?? raw.requested_at ?? 0),
        rejectionReason: raw.rejectionReason ?? raw.rejection_reason ?? undefined
    }
}

export const buildUpsertNomineesRequest = (nominees: Nominee[]): UpsertNomineesRequest =>
    UpsertNomineesRequest.create({ nominees })
